export default __webpack_public_path__ + "6a322a21a768a9919cf2e9d0a433e53b.png";